<ws-modal-wrapper
    [headerLabel]="title"
    [disableSave]="!canSave"
    [disableCancel]="loading"
    [backdropClick]="true"
    [suppressKeyboardEvents]="true"
    [isEditing]="isEdited"
    [loading]="loading"
    (save)="save()"
    (cancel)="cancel()"
>
    @if (!loading) {
        <div class="form-horizontal">
            @if (showFull) {
                <div>
                    @if (yearIsRelevant) {
                        <div class="row mb-4 align-items-center">
                            <label for="comment-year-selection" class="col-md-2 control-label">Year</label>
                            <div class="col-md-10">
                                <select
                                    id="comment-year-selection"
                                    name="taxYear"
                                    class="form-select form-select-sm"
                                    [(ngModel)]="year"
                                    [disabled]="yearDisabled"
                                >
                                    @for (year of availableYears; track year) {
                                        <option [value]="year.value">{{ year.display }}</option>
                                    }
                                </select>
                            </div>
                        </div>
                    }
                    <div class="row mb-4 align-items-center">
                        <label for="comment-title-input" class="col-md-2 control-label">Title</label>
                        <div class="col-md-10">
                            <input
                                type="text"
                                required
                                maxlength="255"
                                class="form-control"
                                id="comment-title-input"
                                [(ngModel)]="commentTitle"
                            />
                        </div>
                    </div>
                    <div class="row mb-4">
                        <label for="comment-description-input" class="col-md-2 control-label">Description</label>
                        <div class="col-md-10">
                            <textarea
                                class="form-control"
                                maxlength="10000"
                                id="comment-description-input"
                                [(ngModel)]="commentBody"
                                [readonly]="readOnly"
                                rows="10"
                                style="resize: none"
                            >
                            </textarea>
                        </div>
                    </div>
                    @if (hasInstancePrivateView) {
                        <div class="row mb-4">
                            <label for="comment-ryan-permissions" class="col-12" style="font-weight: normal">
                                <input id="comment-ryan-permissions" [(ngModel)]="isRyanInternal" type="checkbox" />
                                Only visible to
                                @if (isSingleRyanInstance) {
                                    <span>Ryan</span>
                                }
                                @if (!isSingleRyanInstance) {
                                    <span>Internal</span>
                                }
                                personnel
                            </label>
                        </div>
                    }
                    @if(yearIsRelevant && !!year){
                        <div class="row mb-4">
                            <label for="comment-pin" class="col-12" style="font-weight: normal">
                                <input id="comment-pin" [(ngModel)]="isPinned" type="checkbox">
                                Pin Comment
                            </label>
                        </div>
                    }
                </div>
            }
            @if (!showFull) {
                <div>
                    <textarea
                        class="form-control"
                        cols="40"
                        rows="5"
                        [(ngModel)]="commentBody"
                        autofocus
                        [readonly]="readOnly"
                    ></textarea>
                </div>
            }
        </div>
    }
</ws-modal-wrapper>
